export default {
  projectTypes: (state) => {
    return state.projectTypes;
  },
  projectTypeCode: (state) => {
    return state.projectTypeCode;
  },

  projects: (state) => {
    return state.projects;
  },
  project: (state) => {
    return state.project;
  },
  projectId: (state) => {
    return state.projectId;
  },
  projectCode: (state) => {
    return state.projectCode;
  },

  workDescriptions: (state) => {
    return state.workDescriptions;
  },
  workDescriptionCode: (state) => {
    return state.workDescriptionCode;
  },

  projectTeams: (state) => {
    return state.projectTeams;
  },

  generalEstimates: (state) => {
    return state.generalEstimates;
  },

  buildingProject: (state) => {
    return state.buildingProject;
  },

  suites: (state) => {
    return state.suites;
  },
  suitCode: (state) => {
    return state.suitCode;
  },

  units: (state) => {
    return state.units;
  },
  suiteId: (state) => {
    return state.suiteId;
  },
  unitCode: (state) => {
    return state.unitCode;
  },

  participation: (state) => {
    return state.participation;
  },
  participationCode: (state) => {
    return state.participationCode;
  },
  participationId: (state) => {
    return state.participationId;
  },

  paymentNotification: (state) => {
    return state.paymentNotification;
  },
  paymentNotificationCode: (state) => {
    return state.paymentNotificationCode;
  },

  rank: (state) => {
    return state.rank;
  },
  rankCode: (state) => {
    return state.rankCode;
  },

  estimation: (state) => {
    return state.estimation;
  },
  estimationCode: (state) => {
    return state.estimationCode;
  },
  estimationItem: (state) => {
    return state.estimationItem;
  },
  estimationId: (state) => {
    return state.estimationId;
  },

  transfer: (state) => {
    return state.transfer;
  },
  transferCode: (state) => {
    return state.transferCode;
  },

  crimesReward: (state) => {
    return state.crimesReward;
  },
  crimesRewardCode: (state) => {
    return state.crimesRewardCode;
  },

  crimesRewardSubject: (state) => {
    return state.crimesRewardSubject;
  },
  crimesRewardSubjectCode: (state) => {
    return state.crimesRewardSubjectCode;
  },

  estimationSubject: (state) => {
    return state.estimationSubject;
  },
  estimationSubjectCode: (state) => {
    return state.estimationSubjectCode;
  },

  setting: (state) => {
    return state.setting;
  },

  blocks: (state) => {
    return state.blocks;
  },
  blockCode: (state) => {
    return state.blockCode;
  },

  rankingReport: (state) => {
    return state.rankingReport;
  },

  rankingDetailReport: (state) => {
    return state.rankingDetailReport;
  },

  smsSetting: (state) => {
    return state.smsSetting;
  },

  sendSms: (state) => {
    return state.sendSms;
  },

  paymentNotificationLog: (state) => {
    return state.paymentNotificationLog;
  },
};
